import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=f767544e&"
import script from "./NewsPage.vue?vue&type=script&lang=js&"
export * from "./NewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports